<template>
    <div v-if="bizAuth.viewUser.hasRight" class="biz-view-account-page">
        <view-account-comp :class="{'fixed': listIsFixed}"></view-account-comp>
    </div>
</template>
<script>
import bizBreadcrumb from '@/components/bussiness/widges/tools/bizBreadcrumb.vue';
import viewAccountComp from '@/components/bussiness/internalAuth/accountMgt/viewAccountComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.viewUser.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        bizBreadcrumb,
        viewAccountComp
    }
}
</script>
<style lang="scss" scoped>
    .biz-view-account-page{
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/internalAuth/accountMgt/viewAccount.vue